import React, { Component } from 'react';
import Reveal from 'reveal.js'
import marked from 'marked'
import { parse, stringify } from 'himalaya'
import { readFile } from '../utils/Utils'
import ThemeSelector from '../components/ThemeSelector'

export default class SlideShow extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentWillMount() {
    this.load(this.props.filePath)
  }
  componentWillReceiveProps(props) {
    if (typeof(props)==='object'&&props!==null) {
      this.load(props.filePath)
    }
  }
  load(filePath) {
    if (typeof(filePath)==='string'&&filePath.length>0) {
      const type = filePath.substr(filePath.lastIndexOf('.')+1)
      if (type==='md') {
        readFile(filePath, (data)=>{
          const sections = this.toSections(data)
          this.setState({sections:sections, type:type}, ()=>{
            const config = {
              simple: {
                controls : true,
                progress : true,
                history : true,
                center : true,
                transition : 'slide', // none/fade/slide/convex/concave/zoom
              }
            }
            Reveal.initialize(config.simple)
          })
        })
      } else {
        readFile(filePath, (data)=>{
          this.setState({sections:data}, ()=>{
            const config = {
              simple: {
                controls : true,
                progress : true,
                history : true,
                center : true,
                transition : 'slide', // none/fade/slide/convex/concave/zoom
              }
            }
            Reveal.initialize(config.simple)
          })
        })
      }
    }
  }
  toSections(data) {
    const sections = []
    if (typeof(data)==='string'&&data.length>0) {
      const contents = data.split('===')
      if (Array.isArray(contents)&&contents.length>0) {
        contents.forEach((content,index)=>{
          if (typeof(content)==='string') {
            const section = {
              content: this.markup(content)
            }
            sections.push(section)
          }
        })
      }
    }
    return sections
  }
  markup(s) {
    let content = marked(s)
    if (typeof(content)==='string'&&content.length>0) {
      const json = this.traverse(parse(content))
      return stringify(json)
    }
    return content
  }
  traverse(arr) {
    if (Array.isArray(arr)&&arr.length>0) {
      arr.forEach((e,i)=>{
        arr[i] = this.traverseHelper(e)
      })
      return arr
    }
    return []
  }
  traverseHelper(json) {
    if (typeof(json)==='object'&&json!==null) {
      if (Array.isArray(json)) {
        return this.traverse(json)
      }

      // update with target _blank for external link
      const attrs = json.attributes
      if (Array.isArray(attrs)) {
        for (let i in attrs) {
          const attr = attrs[i]
          if (typeof(attr)==='object') {
            if (attr.key === 'href') {
              const value = attr.value
              if (typeof(value)==='string'&&value.length>0) {
                if (value.startsWith('http')) {
                  attrs.push({
                    key: 'target',
                    value: '_blank'
                  })
                  break
                }
              }
            }
          }
        }
      }

      if (json.hasOwnProperty('children')) {
        if (Array.isArray(json.children) && json.children.length>0) {
          // TODO: make it more flexible
          // find comment with content " .element: class=\"fragment\" "
          json.children.forEach((child,i)=>{
            if (typeof(child)==='object'&&child!==null) {
              if (child.type==='comment' && child.content===' .element: class="fragment" ') {
                // add attr specified in the comment
                const attributes = json.attributes||[]
                const index = attributes.findIndex(e=>e.key==='class')
                if (index>=0) {
                  let value = attributes[index].value||''
                  value +=' fragment'
                  attributes[index].value = value
                  json.attributes = attributes
                } else {
                  attributes.push({
                    key: 'class',
                    value: 'fragment'
                  })
                }
              }
            }
          })
          json.children.forEach((child,i)=>{
            json.children[i] = this.traverseHelper(child)
          })
          return json
        }
      }
    }
    return json
  }
  componentDidMount() {
  }
  done(cb) {
    window.location.reload()
    if (typeof(cb)==='function') {
      cb()
    }
  }
  render() {
    if (this.state.type==='md') {
      return (
        <div className="slides">
          <ThemeSelector mode="link" />
          <section>
            <h1>
              <a
                style={{cursor:'pointer'}}
                onClick={()=>{
                  Reveal.next()
                }}
              >
                {this.props.title||'Start >'}
              </a>
            </h1>
            {/*
              typeof(this.props.done)==='function'&&
              <button onClick={()=>{
                this.done(this.props.done)
              }}>Back</button>
            */}
            <a href="/">&lt; Back to menu</a>
          </section>
  				{
            Array.isArray(this.state.sections)&&
            this.state.sections.map((section, index)=>(
              <section key={index} dangerouslySetInnerHTML={{__html: section.content}}></section>
            ))
          }
          <section style={{textAlign: 'center'}}>
            <h1>THE END</h1>
            <p>Thank you!</p>
            {/*
              typeof(this.props.done)==='function'&&
              <button onClick={()=>{
                this.done(this.props.done)
              }}>Done</button>
            */}
            <a href="/">Done</a>
          </section>
        </div>
      )
    }
    return (
      <div
        className="slides"
        dangerouslySetInnerHTML={{__html: this.state.sections}}
      ></div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/slideshow/SlideShow.js